<template>
  <HeroSection />
  <AutomatedControlSection />
  <BenefitsSection />
  <StatisticsSection />
  <CalculatorSection class="mb-16 md:mb-40" />
  <CtaByTargetMarket />
</template>

<script>
import HeroSection from "@/components/sections/HeroSection.vue";
import AutomatedControlSection from "@/components/sections/AutomatedControlSection.vue";
import BenefitsSection from "@/components/sections/BenefitsSection.vue";
import StatisticsSection from "@/components/sections/StatisticsSection.vue";
import CtaByTargetMarket from "@/components/sections/CtaByTargetMarket.vue";
import CalculatorSection from "@/components/sections/CalculatorSection.vue";

export default {
  name: "FirstDesktop",
  components: {
    CalculatorSection,
    CtaByTargetMarket,
    StatisticsSection,
    BenefitsSection,
    AutomatedControlSection,
    HeroSection,
  },
}
</script>

<style lang="scss">
@import "~@/assets/scss/views/_homeView.scss";
</style>
